import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const CHURCH_CONTENT_PATH = 'licenses.steps.businessInformation.forms.church';

export const churchSchema = BasicBusinessInformationSchema.extend({
  numberOfEventsPerYear: z
    .number({
      required_error: `${CHURCH_CONTENT_PATH}.numberOfEventsPerYear.validation.required`,
    })
    .int({ message: `${CHURCH_CONTENT_PATH}.numberOfEventsPerYear.validation.required` })
    .min(1, { message: `${CHURCH_CONTENT_PATH}.numberOfEventsPerYear.validation.required` }),
});

export type ChurchForm = z.infer<typeof churchSchema>;

export const createChurchDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Church,
});

export const toPayloadChurch = (form: ChurchForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs().format('YYYY-MM-DD'),
    quantity: form.numberOfEventsPerYear ? form.numberOfEventsPerYear : 0,
  };
};
